import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shopflo/ui'
import FilterChips, { FilterChipOption } from 'src/components/common/filter-tabs/FilterChips'

export interface ReportTypeFilter extends FilterChipOption {}

// Chip tabs drive the `type` query param on the report list endpoint.
export const reportTypeFilters: ReportTypeFilter[] = [
  { label: 'All', value: '' },
  { label: 'Orders', value: 'orders' },
  { label: 'Orders Variants', value: 'orders_variant' },
  { label: 'Refunds', value: 'refunds' },
  { label: 'Discounts', value: 'discounts' },
  { label: 'Discounts Performance', value: 'discount_performance' },
]

// Leading dropdown filters the loaded page client-side by frequency type.
// Radix Select forbids an empty-string item value, so "Any" uses a sentinel mapped back to ''.
export const FREQUENCY_ANY = 'any'
export const frequencyFilterOptions = [
  { label: 'Any', value: FREQUENCY_ANY },
  { label: 'Single Report', value: 'ONCE' },
  { label: 'Recurring Report', value: 'RECURRING' }
]

interface ReportsFilterBarProps {
  typeValue: string
  onTypeChange: (value: string) => void
  frequencyValue: string
  onFrequencyChange: (value: string) => void
  /** Tabs beyond this count collapse into a "+N More" popover. */
  maxVisibleTabs?: number
}

const ReportsFilterBar: React.FC<ReportsFilterBarProps> = ({
  typeValue,
  onTypeChange,
  frequencyValue,
  onFrequencyChange,
  maxVisibleTabs = 6
}) => {
  return (
    <FilterChips
      variant='accent'
      tabs={reportTypeFilters}
      value={typeValue}
      onChange={onTypeChange}
      maxVisible={maxVisibleTabs}
      leading={
        <Select
          value={frequencyValue || FREQUENCY_ANY}
          onValueChange={value => onFrequencyChange(value === FREQUENCY_ANY ? '' : value)}
        >
          <SelectTrigger className='h-[22px] w-fit justify-center gap-1 rounded-md border border-solid border-zinc-300 bg-transparent px-1 py-1 !text-text-xs-medium text-zinc-500 shadow-none hover:border-zinc-400 focus:ring-0'>
            <SelectValue placeholder='Any' />
          </SelectTrigger>
          <SelectContent align='start' className='min-w-[160px]'>
            {frequencyFilterOptions.map(option => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      }
    />
  )
}

export default ReportsFilterBar
